import React from 'react';

import { useState, useContext, useEffect } from 'react';
import { StyleSheet, Text, View, KeyboardAvoidingView, TextInput, ScrollView, TouchableOpacity, Alert, ActivityIndicator, Platform } from 'react-native';

import { StatusBar } from 'expo-status-bar';
import * as Device from 'expo-device';
import * as Application from 'expo-application';

import axios from 'axios';
import uuid from 'react-native-uuid';
import CheckBox from '@react-native-community/checkbox';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { CredentialsContext } from '../components/CredentialsContext';
import StyledText from '../components/StyledText';
import BoldStyledText from '../components/BoldStyledText';
import Card from '../components/Card';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';


import envVars from '../env';

const SignUp = props => {

  const [phoneNumber, setPhoneNumber] = useState([]);
  const [phoneNumberInputIsFocused , setPhoneNumberInputIsFocused] = useState(false);
  const [language, setLanguage] = useState('Persian')

  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);
  
  const strings = () => {
    if(language == 'English') {
        return EnglishStrings
    } else if(language == 'Arabic') {
        return ArabicStrings
    } else return PersianStrings
  }

  useEffect(()=> {
    // changeLanguage('Arabic')

    props.navigation.setOptions({
      headerStyle:{
        backgroundColor: 'transparent'
      },
      headerTransparent: true,
      headerTitle: '',
      headerLeftContainerStyle:{
        paddingLeft: 20
      }
    });

  }, [])

  const changeLanguage = targetLanguage => {
    if(language != targetLanguage) {
        const updatedStoredCredentials = {...storedCredentials, ...{language: targetLanguage}}

        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
        .then(()=> {
            setStoredCredentials(updatedStoredCredentials)
        })
        .catch(err =>{
            console.log(err);
        })        
        
        setLanguage(targetLanguage)
    }
  }

  const handleSignup = (enteredPhoneNumber) =>{

    const url = envVars.SERVER_URL +  envVars.SERVER_PORT + '/signup';
    const userDeviceIDHandler = () => {
      if (Platform.OS == 'android') {
        return Application.androidId
      } else if (Platform.OS == 'ios') {
        return Application.getIosIdForVendorAsync()
      } else if (Platform.OS == 'web') {
        const uniqueID = uuid.v4();
        const uniqueIDArr = uniqueID.split("-")
        var deviceID = '';
        uniqueIDArr.forEach(element => {
          deviceID = deviceID + element
        });
        return deviceID 
      }
    };
    const credentials = { 
      userPhoneNumber: enteredPhoneNumber,
      userDeviceID: userDeviceIDHandler(),
      userDeviceInfo: Device.modelName + '//' + Device.osName
    };

    if(enteredPhoneNumber == ""){
      if(Platform.OS == 'web') {
        const res = window.alert(strings().pleaseEnterRequestedInformations)
      } else {
        Alert.alert('',strings().pleaseEnterRequestedInformations,[
          {
            text: strings().ok
          }
        ])
      }
    } else {
      setIsSubmitting(true);

      axios.post(url,credentials).then((res)=> {
        setIsSubmitting(false);
        const result = res.data;
        const {message, status, data} = result;

        if(status == 'SUCCESS') {
          props.navigation.navigate('Activation with SMS', {enteredPhoneNumber, language})
        } else {
          if(Platform.OS == 'web') {
            const res = window.alert(strings().serverInternalError)
          } else {
            Alert.alert('',strings().serverInternalError,[
              {
                text: strings().ok
              }
            ])
          }
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  
      
  };
  
  return (
    <KeyboardAvoidingView style={{flex: 1}}>
      <ScrollView contentContainerStyle={{flexGrow: 1}}>
      <View style={Styles.wrapper}>

      <StatusBar />
        <View style={Styles.contentWrapper}>
          <View style={{...Styles.headerCard, ...language == 'English' && {flexDirection: 'row'}}}>
            <View style={{justifyContent: 'center'}} > 
              <BoldStyledText style={Styles.cardHeaderText}> {strings().signIn} </BoldStyledText>
              <View style={Styles.descriptionOrSignin}>
                <StyledText style={Styles.cardHeaderTextDescription}> {strings().enterYourPhoneNumber} </StyledText>
              </View>
            </View>

            <Card style={{backgroundColor: 'gray', padding: 5 }} activeOpacity={1}>
              <TouchableOpacity style={{margin: 5}} onPress={()=> changeLanguage('Persian')}>
                <BoldStyledText style={{color: language == 'Persian' ? '#1C0947' : 'white', fontSize: 10}}> FA </BoldStyledText>
              </TouchableOpacity>
              <TouchableOpacity style={{margin: 5}} onPress={()=> changeLanguage('English')}>
                <BoldStyledText style={{color: language == 'English' ? '#1C0947' : 'white', fontSize: 10}}> EN </BoldStyledText>
              </TouchableOpacity>
              <TouchableOpacity style={{margin: 5}}  onPress={()=> changeLanguage('Arabic')}>
                <BoldStyledText style={{color: language == 'Arabic' ? '#1C0947' : 'white', fontSize: 10}}> AR </BoldStyledText>
              </TouchableOpacity>
            </Card>
            
          </View>

          <View style={Styles.textInputWrapper} >
            <View style={Styles.InputArea} >
              <StyledText style={Styles.inputLabel}> {strings().phoneNumber} </StyledText>
              <TextInput 
                style={{...Styles.textInput, ...{borderColor: phoneNumberInputIsFocused ? 'blue' : 'white', borderWidth:1}}}
                keyboardType= 'numeric'
                placeholder='09021222988'
                onFocus={()=> setPhoneNumberInputIsFocused(true) }
                onBlur={()=> setPhoneNumberInputIsFocused(false) }
                onChangeText={value => setPhoneNumber(value)} />
            </View>
          </View>
        </View>

        <View style={Styles.footer}>
          <TouchableOpacity style={Styles.submitBtn} 
            onPress={()=> {isSubmitting ? {} : handleSignup(phoneNumber)} }>
            {isSubmitting 
            ? <ActivityIndicator size="large" />
            : <StyledText style={Styles.submitBtnText}> {strings().sendCode} </StyledText>
            }
          </TouchableOpacity> 
          <View style={{flexDirection:'row-reverse', alignItems: 'center',justifyContent: 'center', marginHorizontal: '8%', marginVertical: 5}}>
            {/* <CheckBox /> */}
            <BoldStyledText> قوانین و شرایط حریم خصوصی را قبول می کنم. </BoldStyledText>
            <TouchableOpacity
              onPress={()=> props.navigation.navigate('Terms and policies')}
            >
              <BoldStyledText style={{color: '#1C0947'}}> مشاهده </BoldStyledText>
            </TouchableOpacity>

          </View>

            
            
        </View>
      </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};


let Styles = {  
  wrapper:{
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: '#F26B08',
  },
  contentWrapper:{

  },
  headerCard:{
    width:'100%',
    minHeight: 250,
    height:'20%',
    padding: 15,
    alignSelf:'center',
    backgroundColor:'white',
    shadowColor: 'black',
    shadowOffset: {width:0 , height:2},
    shadowRadius: 6,
    shadowOpacity: 0.26,
    elevation:20,
    borderBottomStartRadius: 60 ,
    padding: 20,
    height: '30%',
    backgroundColor: '#1C0947',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cardHeaderText:{
    fontWeight:'400',
    fontSize:50,
    color: 'white',
    // alignSelf: 'flex-end'
  },
  descriptionOrSignin:{
    flexDirection:'row-reverse'
  },
  topSignInBtn:{
    backgroundColor: '#00008B',
    borderRadius: 10,
    paddingHorizontal: 5
  },
  cardHeaderTextDescription:{
    fontSize:20,
    fontWeight:'300',
    color:'white',
    // paddingVertical: 5,
    margin:5
  },
  textInputWrapper:{
    alignItems: 'flex-end',
    margin: '5%',
    marginTop: '10%',
  },
  textInput:{
    backgroundColor: 'white',
    padding: 15,
    marginTop: 10,
    marginBottom: 20,
    borderRadius: 40,
    shadowColor: 'black',
    shadowOffset: {width:0 , height:2},
    shadowRadius: 6,
    shadowOpacity: 0.26,
    elevation:20,
    fontSize: 25,
  },
  inputLabel:{
    fontSize: 20,
    fontWeight: '500',
    color: 'white'
  },
  InputArea:{
    width: '100%',  
  },
  passwordWarningText:{
    color: 'red',

  },
  footer:{
    paddingVertical:10,
    // marginBottom: 10,
  },
  submitBtn:{
    backgroundColor: '#1C0947',
    alignItems: 'center',
    marginHorizontal:'5%',
    borderRadius: 40,
    minHeight: 60,
    justifyContent: 'center'
  },
  TermsAndPolicesBTN:{
    // backgroundColor: '#1C0947',
    // alignItems: 'center',

    marginHorizontal:'8%',
    borderRadius: 40,
    minHeight: 60,
    justifyContent: 'center'
  },
  submitBtnText:{
    fontSize: 35,
    fontWeight: '300',
    color:'white',
    padding:5
  },
  alreadySinedUpTextArea:{
    alignItems:'center',
    marginTop: '5%'
  },
  alreadySinedUpText:{
    color: '#6F8FEA'
  }
}

// const Styles = StyleSheet.create({  
//   wrapper:{
//     flex: 1,
//     justifyContent: 'space-between',
//     backgroundColor: '#F5F6FA',
//   },
//   contentWrapper:{

//   },
//   headerCard:{
//     width:'100%',
//     minHeight: 250,
//     height:'20%',
//     padding: 15,
//     alignSelf:'center',
//     backgroundColor:'white',
//     shadowColor: 'black',
//     shadowOffset: {width:0 , height:2},
//     shadowRadius: 6,
//     shadowOpacity: 0.26,
//     elevation:20,
//     borderBottomStartRadius: 60 ,
//     padding: 20,
//     height: '30%',
//     backgroundColor: '#5A6BE1'
//   },
//   cardHeaderText:{
//     fontWeight:'500',
//     fontSize:50,
//     color: 'white',
//     alignSelf: 'flex-end',
//     paddingTop: '20%',
//   },
//   descriptionOrSignin:{
//     flexDirection:'row-reverse'
//   },
//   topSignInBtn:{
//     backgroundColor: '#00008B',
//     borderRadius: 10,
//     paddingHorizontal: 5
//   },
//   cardHeaderTextDescription:{
//     fontSize:20,
//     fontWeight:'200',
//     color:'white',
//     paddingVertical: 10,
//     margin:5
//   },
//   textInputWrapper:{
//     alignItems: 'flex-end',
//     margin: '5%',
//     marginTop: '10%',
//   },
//   textInput:{
//     backgroundColor: 'white',
//     padding: 15,
//     marginTop: 10,
//     marginBottom: 20,
//     borderRadius: 40,
//     shadowColor: 'black',
//     shadowOffset: {width:0 , height:2},
//     shadowRadius: 6,
//     shadowOpacity: 0.26,
//     elevation:20,
//     fontSize: 25,
//   },
//   inputLabel:{
//     fontSize: 20,
//     fontWeight: '500',
//     color: '#9797A8'
//   },
//   InputArea:{
//     width: '100%',  
//   },
//   passwordWarningText:{
//     color: 'red',

//   },
//   footer:{
//     paddingVertical:10,
//     marginBottom: 10,
//   },
//   submitBtn:{
//     backgroundColor: '#5A6BE1',
//     alignItems: 'center',
//     marginHorizontal:'5%',
//     borderRadius: 40,
//     minHeight: 60,
//     justifyContent: 'center'
//   },
//   submitBtnText:{
//     fontSize: 35,
//     fontWeight: '300',
//     color:'white',
//     padding:5
//   },
//   alreadySinedUpTextArea:{
//     alignItems:'center',
//     marginTop: '5%'
//   },
//   alreadySinedUpText:{
//     color: '#6F8FEA'
//   }
// });

export default SignUp;